// 2 点間の Haversine 距離 (km)。
// オフライン最近傍検索 (api.ts) と「近くの地点」リスト (StationPicker) で共有する。

const EARTH_RADIUS_KM = 6371.0088;

const toRad = (d: number): number => (d * Math.PI) / 180;

export function haversineKm(
  la1: number,
  lo1: number,
  la2: number,
  lo2: number,
): number {
  const dLa = toRad(la2 - la1);
  const dLo = toRad(lo2 - lo1);
  const a =
    Math.sin(dLa / 2) ** 2 +
    Math.cos(toRad(la1)) * Math.cos(toRad(la2)) * Math.sin(dLo / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(a));
}
